module.exports = "/_next/static/images/2583d7a341646ff79004d641e4827dfa-phone@3x.png";